export default __webpack_public_path__ + "static/media/486.f87a2170.png";